import { ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

const blocks = [
  { n:"01", title:"Transaction", lead:"Repérez les projets qui méritent un rappel rapide.", quote:"Je souhaite vendre mon appartement avant la fin de l'année.", items:["Estimation ou vente","Secteur et type de bien","Délai du projet"], link:"/qualification-appels-immobilier" },
  { n:"02", title:"Location", lead:"Absorbez le volume sans répéter les mêmes questions.", quote:"Je vous appelle pour le T2 publié ce matin.", items:["Situation professionnelle","Revenus et garants","Date d'entrée souhaitée"], link:"/permanence-telephonique-immobilier" },
];

const FeaturesSection = () => (
  <section id="features" className="bg-secondary/55 py-16 md:py-20 lg:py-24">
    <div className="mx-auto max-w-[1344px] px-5 md:px-8">
      <div className="max-w-3xl">
        <p className="eyebrow">Deux quotidiens, une même logique</p>
        <h2 className="mt-5 text-4xl font-semibold tracking-[-.04em] md:text-[56px] md:leading-[1.04]">Moins de tri. Plus de temps pour le métier.</h2>
      </div>
      <div className="mt-12 border-t border-foreground/20">
        {blocks.map((b) => (
          <div key={b.title} className="grid gap-7 border-b border-border py-9 lg:grid-cols-12 lg:py-11">
            <span className="font-mono text-[11px] text-primary lg:col-span-1">{b.n}</span>
            <div className="lg:col-span-3">
              <h3 className="text-[28px] font-semibold tracking-tight">{b.title}</h3>
              <p className="mt-3 text-[14px] leading-6 text-muted-foreground">{b.lead}</p>
            </div>
            <blockquote className="relative border-l-2 border-accent pl-5 text-[19px] leading-8 lg:col-span-4">
              « {b.quote} »
            </blockquote>
            <div className="lg:col-span-3 lg:col-start-10">
              <ul className="space-y-3">
                {b.items.map((x) => <li key={x} className="flex gap-2 text-[14px]"><Check className="mt-0.5 h-4 w-4 text-primary" />{x}</li>)}
              </ul>
              <Link to={b.link} className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary">
                Voir le cas d'usage <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
export default FeaturesSection;